<title>Autoverkoop Partner - Aanvraag status</title>

<!-- Page Content -->
<div class="container">
  <div class="card border-0 shadow my-5">
    <div class="card-body p-5">
      <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
      <hr>

        <h1 class="font-weight-light">Aanvraag status</h1>

        @if (valuationDetailData) {
          <div class="mt-4 mb-4">
            <p>Aanvraagnummer: {{valuationDetailData.id}}</p>
            <div class="row d-flex cart">
              <div class="col-md-12">
                <div class="card">
                  <div class="row g-0">
                    <div class="col-md-6 border-right p-5">
                      <div class="text-center order-details">
                        <div class="d-flex justify-content-center mb-5 flex-column align-items-center">
                          <span class="check1">
                            <fa-icon [icon]="faCheck"></fa-icon>
                            </span> <span class="font-weight-bold">Aanvraag bevestigd</span>
                            <small class="mt-2">Op dit moment is er geen actie nodig.</small>
                            <small class="mt-2">Vragen? Neem gerust contact op met onze
                            klantenservice.</small>
                          </div>
                          <button onclick="location.href='https://autoverkooppartner.nl/klantenservice/';"
                          class="btn btn-warning btn-block order-button">Neem contact op</button>
                        </div>
                      </div>
                      <div class="col-md-6 background-muted">
                        <ngb-carousel class="col-md-12">
                          @for (image of valuationDetailData.VehicleSpecification.Images; track image) {
                            <ng-template
                              ngbSlide>
                              <div class="picsum-img-wrapper">
                                <img style="max-height: 200px; margin-left: auto;   margin-right: auto; display: block;"
                                  class="img-fluid" [src]="image.imageUrl" alt="Random first slide">
                              </div>
                            </ng-template>
                          }
                        </ngb-carousel>
                        <div class="p-3 border-bottom">
                          <div class="d-flex align-items-center">
                            <span><i
                            class="fa fa-clock-o text-muted"></i>{{valuationDetailData.VehicleSpecification.Vehicle.registration}}
                          - </span>
                          <span><i
                          class="fa fa-refresh text-muted"></i>&nbsp;{{valuationDetailData.VehicleSpecification.Vehicle.make}}
                        {{valuationDetailData.VehicleSpecification.Vehicle.modelSpecific}}</span>
                      </div>
                      <div class="mt-3">
                        <h6 class="mb-0"><b>Geselecteerde ophaaldatum:</b> {{valuationDetailData.dateDelivery.date | date: 'dd-MM-yyyy'}}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <div style="height: 700px"></div>
    </div>
  </div>
</div>